(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3455],{

/***/ 18740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-us",
      function () {
        return __webpack_require__(36079);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ StyledOfferFooterContainer; },
/* harmony export */   "NN": function() { return /* binding */ StyledOfferFooterScoutName; },
/* harmony export */   "O9": function() { return /* binding */ StyledOfferFooterScoutTitle; },
/* harmony export */   "U9": function() { return /* binding */ StyledOfferFooterScoutLabel; },
/* harmony export */   "V6": function() { return /* binding */ StyledOfferFooterTitle; },
/* harmony export */   "Vj": function() { return /* binding */ StyledOfferFooterText; },
/* harmony export */   "WD": function() { return /* binding */ StyledOfferFooter; },
/* harmony export */   "iP": function() { return /* binding */ StyledOfferFooterScout; },
/* harmony export */   "re": function() { return /* binding */ StyledOfferFooterActions; },
/* harmony export */   "xh": function() { return /* binding */ StyledOfferFooterLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);
/* harmony import */ var _shared_Avatar_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11472);
/* harmony import */ var _shared_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99655);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img{ \n    display: block;\n    max-height: 8rem;\n    max-width: 15rem;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: ",
        ";\n  > * {\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  line-height: 1.25;\n  color: ",
        ";\n  max-width: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.33;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: left;\n\n  ",
        " {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.33;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.14;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var StyledOfferFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
    componentId: "sc-42dd8dc8-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"));
var StyledOfferFooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .container */ .nC)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_700"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_700"));
var StyledOfferFooterLogo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledOfferFooterTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Heading4 */ .k8).withConfig({
    componentId: "sc-42dd8dc8-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledOfferFooterActions = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-4"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledOfferFooterText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-42dd8dc8-5"
})(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle_inverse"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .container */ .nC)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"));
var StyledOfferFooterScoutTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-42dd8dc8-6"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledOfferFooterScout = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-7"
})(_templateObject7(), _shared_Avatar_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledAvatar */ .b, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledOfferFooterScoutLabel = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-42dd8dc8-8"
})(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle_inverse"));
var StyledOfferFooterScoutName = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-42dd8dc8-9"
})(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("link_inverse"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"));


/***/ }),

/***/ 55009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WORK_AT_MANFRED_KEY; }
/* harmony export */ });
var WORK_AT_MANFRED_KEY = "isInterestedOnWorkAtManfred";


/***/ }),

/***/ 11472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ StyledAvatar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 0;\n  border-radius: ",
        ";\n  transition: 0.3s;\n\n  img {\n    display: block;\n    object-fit: cover;\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var sizeVariants = {
    sm: {
        width: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"),
        height: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl")
    },
    lg: {
        width: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"),
        height: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4")
    }
};
var StyledAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7188bb60-0"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), sizeVariants[sizes].width, sizeVariants[sizes].height);
});


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 23793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* reexport safe */ _useToasts__WEBPACK_IMPORTED_MODULE_0__.e; }
/* harmony export */ });
/* harmony import */ var _useToasts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57064);



/***/ }),

/***/ 36079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ join_us; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsBenefits.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n  text-align: center;\n\n  > div {\n    max-width: ",
        ";\n    margin: auto;\n    margin-top: ",
        ";\n    padding-top: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    @media (min-width: ",
        ") {\n      display: flex;\n      flex-direction: row-reverse;\n      gap: ",
        ";\n    }\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 14rem;\n\n  p {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 4.68rem;\n  max-height: 4.68rem;\n  margin-bottom: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    font-weight: ",
        ";\n    text-transform: uppercase;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledBenefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cf135f2-0"
})(_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl3"));
var StyledBenefitsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cf135f2-1"
})(_templateObject1(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"));
var StyledItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cf135f2-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("sm"));
var StyledItemIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4cf135f2-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"));
var StyledItemTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4cf135f2-4"
})(_templateObject4(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs2"));

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsBenefits.tsx





var JoinUsBenefits = function() {
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var benefits = [
        {
            id: "flextime",
            icon: "clock"
        },
        {
            id: "holidays",
            icon: "holidays"
        },
        {
            id: "flexlocation",
            icon: "remote"
        },
        {
            id: "machine",
            icon: "devices"
        },
        {
            id: "schooling",
            icon: "continuous-learning"
        },
        {
            id: "speakers",
            icon: "proactivity"
        },
        {
            id: "retribution",
            icon: "perk"
        },
        {
            id: "teambuilding",
            icon: "teamwork"
        },
        {
            id: "care",
            icon: "gift"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBenefits, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("benefits.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBenefitsList, {
                children: benefits.map(function(b, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemIcon, {
                                src: (0,paths/* getPublicPath */.A)("/images/icons/" + b.icon + ".svg"),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemTitle, {
                                children: t("benefits.items.".concat(b.id, ".title"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("benefits.items.".concat(b.id, ".desc"))
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var joinUs_JoinUsBenefits = (JoinUsBenefits);

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsComponent.styled.ts

function JoinUsComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -",
        ";\n"
    ]);
    JoinUsComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledJoinUs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-514b09f0-0"
})(JoinUsComponent_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"));

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@auth0/nextjs-auth0/dist/client/index.js
var client = __webpack_require__(5778);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ./components/jobOffer/footer/OfferFooter.styled.js
var OfferFooter_styled = __webpack_require__(6791);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsFooter.styled.js

function JoinUsFooter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  line-height: 1.25;\n  color: ",
        ";\n  max-width: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    JoinUsFooter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledJoinUsFooterText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0ee9d15-0"
})(JoinUsFooter_styled_templateObject(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"));

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./hooks/api/manfredite/index.ts + 4 modules
var api_manfredite = __webpack_require__(33219);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsLoggedInModal.hooks.ts







var useJoinUsLoggedInModal = function(param) {
    var onClose = param.onClose;
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var manfredite = (0,api_manfredite/* useManfredite */.CV)().manfredite;
    var updateManfrediteFromModel = (0,api_manfredite/* useManfrediteUpdate */.OB)().updateManfrediteFromModel;
    var ref = (0,react.useState)(false), isApplying = ref[0], setIsApplying = ref[1];
    var ref1 = (0,useToasts/* useToasts */.e)(), addErrorToast = ref1.addErrorToast, addSuccessToast = ref1.addSuccessToast;
    var onApplyClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!manfredite) return [
                        2
                    ];
                    setIsApplying(true);
                    return [
                        4,
                        updateManfrediteFromModel(manfredite, {
                            isInterestedOnWorkAtManfred: true
                        }, {
                            onSuccess: function() {
                                addSuccessToast(t("modal.messages.success.apply"));
                                setIsApplying(false);
                                onClose();
                            },
                            onError: function(ex) {
                                console.error("[JoinUsLoggedInModal] Could not apply to Work at Manfred. Exception: ".concat(ex));
                                addErrorToast(t("modal.messages.error.apply.desc", {
                                    error: (0,errors/* getErrorMessage */.e)(ex)
                                }), t("modal.messages.error.apply.title"));
                                setIsApplying(false);
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        addErrorToast,
        addSuccessToast,
        manfredite,
        onClose,
        t,
        updateManfrediteFromModel
    ]);
    return {
        t: t,
        isApplying: isApplying,
        onApplyClick: onApplyClick
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsLoggedInModal.tsx




var JoinUsLoggedInModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var ref = useJoinUsLoggedInModal({
        onClose: onClose
    }), t = ref.t, isApplying = ref.isApplying, onApplyClick = ref.onApplyClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Modal */.u_, {
        title: t("modal.apply.title"),
        closeable: false,
        isOpen: isOpen,
        buttonsSlot: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                    label: t("modal.actions.apply"),
                    startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                    size: "xs",
                    onClick: onApplyClick,
                    isLoading: isApplying,
                    loadingText: t("modal.actions.applying")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                    label: t("modal.actions.cancel"),
                    startIcon: pro_solid_svg_icons/* faTimesCircle */.nYk,
                    variant: "bare",
                    size: "xs",
                    onClick: onClose
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Paragraph */.nv, {
            children: t("modal.apply.desc")
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../ui-common/dist/index.js + 26 modules
var ui_common_dist = __webpack_require__(49976);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./components/marketingSite/joinUs/JoinUsNotLoggedInModal.constants.ts
var JoinUsNotLoggedInModal_constants = __webpack_require__(55009);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsNotLoggedInModal.tsx













var JoinUsNotLoggedInModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,_sliced_to_array/* default */.Z)((0,ui_common_dist/* useLocalStorage */._)(JoinUsNotLoggedInModal_constants/* WORK_AT_MANFRED_KEY */.Z, false), 2), setWorkAtManfred = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Modal */.u_, {
        closeable: false,
        isOpen: isOpen,
        buttonsSlot: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                    sizes: "sm",
                    onClick: function() {
                        return setWorkAtManfred(true);
                    },
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faSignIn */.Yem
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("modal.actions.register")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                    sizes: "sm",
                    variant: "secondary",
                    onClick: function() {
                        return setWorkAtManfred(true);
                    },
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.login */.uu.login, locale), "?locale=").concat(locale),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faSignIn */.Yem
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("modal.actions.login")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                    label: t("modal.actions.cancel"),
                    startIcon: pro_solid_svg_icons/* faTimesCircle */.nYk,
                    variant: "bare",
                    size: "xs",
                    onClick: onClose
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (0,paths/* getPublicPath */.A)("/images/joinUs/Spaceship_Planet.png"),
                alt: "",
                width: 152,
                height: 164
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                as: "h3",
                size: "xl",
                children: t("modal.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Paragraph */.nv, {
                children: t("modal.desc")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsFooter.tsx










var JoinUsFooter = function() {
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var user = (0,client/* useUser */.aF)().user;
    var ref = (0,react.useState)(false), isJoinUsModalOpened = ref[0], setJoinUsModalOpened = ref[1];
    var onSendCVClick = function() {
        return setJoinUsModalOpened(true);
    };
    var onCloseModal = function() {
        return setJoinUsModalOpened(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferFooter_styled/* StyledOfferFooter */.WD, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferFooter_styled/* StyledOfferFooterContainer */.D, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterTitle */.V6, {
                        children: t("footer.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJoinUsFooterText, {
                        dangerouslySetInnerHTML: {
                            __html: t("footer.desc")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterActions */.re, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                            onClick: onSendCVClick,
                            label: t("footer.sendCV"),
                            startIcon: free_solid_svg_icons/* faCheckCircle */.f8k,
                            schema: "brand2"
                        })
                    })
                ]
            }),
            user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinUsLoggedInModal, {
                isOpen: isJoinUsModalOpened,
                onClose: onCloseModal
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinUsNotLoggedInModal, {
                isOpen: isJoinUsModalOpened,
                onClose: onCloseModal
            })
        ]
    });
};
/* harmony default export */ var joinUs_JoinUsFooter = (JoinUsFooter);

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsHero.styled.tsx

function JoinUsHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat, no-repeat, no-repeat;\n  background-position: top 2.5rem center, bottom, bottom;\n  background-size: 8rem, contain, cover;\n  padding: ",
        " 0 54vw;\n  position: relative;\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    min-height: 100vh;\n    background-image: ",
        ";\n    padding: ",
        " 0 36vw;\n    background-size: auto, cover, cover;\n    background-position: top 3rem right 5vw, bottom, bottom;\n  }\n"
    ]);
    JoinUsHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JoinUsHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  background-image: ",
        ";\n  background-color: transparent;\n  background-repeat: repeat-x;\n  background-position: 0 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  z-index: 0;\n\n  @media (min-width: ",
        ") {\n    background-position: top;\n  }\n\n  > div {\n    width: 100vw;\n    height: 100vh;\n    position: absolute;\n    overflow: hidden;\n    transform: rotate(145deg);\n  }\n"
    ]);
    JoinUsHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JoinUsHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 2px;\n  background: linear-gradient(-45deg, #f67784, rgba(246, 119, 132, 0));\n  border-radius: 999px;\n  filter: drop-shadow(0 0 4px #f67784);\n  animation: tail 4s ease-in-out infinite, shooting 4s ease-in-out infinite;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: calc(50% - 1px);\n    right: 0;\n    height: 2px;\n    transform: translateX(50%) rotate(45deg);\n    border-radius: 100%;\n    animation: shining 4s ease-in-out infinite;\n  }\n\n  &::after {\n    transform: translateX(50%) rotate(-45deg);\n  }\n\n  &:first-child {\n    top: 37vw;\n    left: 13vw;\n    animation-delay: 6.88s;\n\n    &::before,\n    &::after {\n      animation-delay: 6.88s;\n    }\n  }\n\n  &:nth-child(2) {\n    top: 44vw;\n    left: 34vw;\n    animation-delay: 2.55s;\n\n    &::before,\n    &::after {\n      animation-delay: 2.55s;\n    }\n  }\n\n  &:nth-child(3) {\n    top: 51vw;\n    left: 13vw;\n    animation-delay: 8438ms;\n\n    &::before,\n    &::after {\n      animation-delay: 8438ms;\n    }\n  }\n\n  &:nth-child(4) {\n    top: 58vw;\n    left: 14vw;\n    animation-delay: 8742ms;\n\n    &::before,\n    &::after {\n      animation-delay: 8742ms;\n    }\n  }\n\n  &:nth-child(5) {\n    top: 65vw;\n    left: 80vw;\n    animation-delay: 4275ms;\n\n    &::before,\n    &::after {\n      animation-delay: 4275ms;\n    }\n  }\n\n  @keyframes tail {\n    0% {\n      width: 0;\n    }\n    30% {\n      width: 100px;\n    }\n    100% {\n      width: 0;\n    }\n  }\n\n  @keyframes shooting {\n    0% {\n      transform: translateX(0);\n    }\n    100% {\n      transform: translateX(300px);\n    }\n  }\n\n  @keyframes shining {\n    0% {\n      width: 0;\n    }\n    50% {\n      width: 30px;\n    }\n    to {\n      width: 0;\n    }\n  }\n"
    ]);
    JoinUsHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JoinUsHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-top: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n"
    ]);
    JoinUsHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function JoinUsHero_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.4;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  .cta {\n    font-size: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    JoinUsHero_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d363cdf-0"
})(JoinUsHero_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/joinUs/planet.svg"), "'), url('").concat((0,paths/* getPublicPath */.A)("/images/joinUs/mountains-mobile.svg"), "'), linear-gradient(180deg,#3b3552,#3b3552 57%,#df5440 153%)");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/joinUs/planet.svg"), "'),url('").concat((0,paths/* getPublicPath */.A)("/images/joinUs/mountains.svg"), "'), linear-gradient(180deg,#3b3552,#3b3552 57%,#df5440 153%)");
}, (0,theme/* spacing */.W0)("xl4"));
var StyledHeroStars = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d363cdf-1"
})(JoinUsHero_styled_templateObject1(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/joinUs/stars.svg"), "')");
}, (0,theme/* screen */.sp)("md"));
var StyledHeroShootingStar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d363cdf-2"
})(JoinUsHero_styled_templateObject2());
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d363cdf-3"
})(JoinUsHero_styled_templateObject3(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledHeroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d363cdf-4"
})(JoinUsHero_styled_templateObject4(), (0,theme/* container */.nC)("lg"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xl3"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-9d363cdf-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("lg"));
var StyledHeroActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d363cdf-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl3"));

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsHero.tsx



var JoinUsHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroStars, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroShootingStar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroShootingStar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroShootingStar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroShootingStar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroShootingStar, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                            editorial: true,
                            children: t("join.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("join.desc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "cta",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("join.cta")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var joinUs_JoinUsHero = (JoinUsHero);

// EXTERNAL MODULE: ./features/job-offers/list/components/grid/card/OfferCard.tsx + 7 modules
var OfferCard = __webpack_require__(58503);
;// CONCATENATED MODULE: ./features/job-offers/list/components/grid/card/index.ts


// EXTERNAL MODULE: ../../node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(97000);
// EXTERNAL MODULE: ../../node_modules/react-reveal/Fade.js
var Fade = __webpack_require__(24647);
var Fade_default = /*#__PURE__*/__webpack_require__.n(Fade);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsPositions.styled.tsx

function JoinUsPositions_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    JoinUsPositions_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JoinUsPositions_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.loading {\n    opacity: 0.2;\n    pointer-events: none;\n  }\n  .masonry-grid {\n    display: flex;\n    margin-left: -",
        "; /* gutter size offset */\n    width: auto;\n  }\n  .masonry-column {\n    padding-left: ",
        "; /* gutter size */\n    background-clip: padding-box;\n\n    &:empty {\n      display: none;\n    }\n\n    > div {\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    JoinUsPositions_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledPositions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f1d83e0-0"
})(JoinUsPositions_styled_templateObject(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl3"));
var StyledPositionsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f1d83e0-1"
})(JoinUsPositions_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsPositions.tsx








var JoinUsPositions = function(param) {
    var offers = param.offers;
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var breakpointColumnsObj = {
        default: 3,
        890: 2,
        550: 1
    };
    if ((offers === null || offers === void 0 ? void 0 : offers.length) <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPositions, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("careers.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPositionsGrid, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                    breakpointCols: breakpointColumnsObj,
                    className: "masonry-grid",
                    columnClassName: "masonry-column",
                    children: offers.map(function(offer, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Fade_default()), {
                                bottom: true,
                                distance: "10px",
                                ssrReveal: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCard/* OfferCard */.F, {
                                    offer: offer
                                })
                            })
                        }, i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var joinUs_JoinUsPositions = (JoinUsPositions);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var lib = __webpack_require__(23467);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsTeam.styled.tsx

function JoinUsTeam_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n\n  > div {\n    max-width: ",
        ";\n    margin: auto;\n    margin-top: ",
        ";\n    padding-top: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    @media (min-width: ",
        ") {\n      display: flex;\n      flex-direction: row-reverse;\n      gap: ",
        ";\n    }\n  }\n"
    ]);
    JoinUsTeam_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JoinUsTeam_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: 1.5em;\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n\n    &::before {\n      left: 0;\n      transform: unset;\n    }\n  }\n"
    ]);
    JoinUsTeam_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JoinUsTeam_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  max-width: ",
        ";\n\n  .slick-slider {\n    padding-bottom: 0;\n  }\n\n  .slick-dots {\n    bottom: -",
        ";\n\n    li button {\n      background-color: ",
        ";\n      border-color: ",
        ";\n\n      &:hover {\n        border-color: ",
        ";\n      }\n    }\n\n    li.slick-active button {\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    JoinUsTeam_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JoinUsTeam_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  overflow: hidden;\n  margin: 0;\n  margin-top: -1px;\n"
    ]);
    JoinUsTeam_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function JoinUsTeam_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  border-top-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  height: 21rem;\n  width: 100%;\n  object-fit: cover;\n  margin-top: -0.5px;\n"
    ]);
    JoinUsTeam_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function JoinUsTeam_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  padding: ",
        ";\n  display: flex;\n  text-align: left;\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    JoinUsTeam_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var StyledTeam = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25da4365-0"
})(JoinUsTeam_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledTeamIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25da4365-1"
})(JoinUsTeam_styled_templateObject1(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl"));
var StyledTeamSlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-25da4365-2"
})(JoinUsTeam_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* container */.nC)("xs"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("black"), (0,theme/* color */.$_)("midnight_700"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("active"));
var StyledTeamSlide = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-25da4365-3"
})(JoinUsTeam_styled_templateObject3(), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"));
var StyledTeamSlideImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-25da4365-4"
})(JoinUsTeam_styled_templateObject4(), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"));
var StyledTeamSlideCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-25da4365-5"
})(JoinUsTeam_styled_templateObject5(), (0,theme/* color */.$_)("midnight_850"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("emerald_600"));

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsTeam.tsx













var JoinUsTeamComponent = function() {
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var locale = (0,client_router.useRouter)().locale;
    var settings = {
        dots: true,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    var teamSlides = [
        {
            caption: "team1",
            img: "team1.jpg"
        },
        {
            caption: "team2",
            img: "team2.jpg"
        },
        {
            caption: "team3",
            img: "team3.jpg"
        },
        {
            caption: "team4",
            img: "team4.jpg"
        },
        {
            caption: "team5",
            img: "team5.jpg"
        },
        {
            caption: "team6",
            img: "team6.jpg"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeam, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamIntro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            editorial: true,
                            children: t("who.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: t("who.desc")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                t("who.knowOurFredders"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.team */.uu.team, locale),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: t("who.here")
                                    })
                                }),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamSlider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                        children: teamSlides.map(function(s, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamSlide, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamSlideImg, {
                                        src: (0,paths/* getPublicPath */.A)("/images/joinUs/" + s.img),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamSlideCaption, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faInfoCircle */.sqG
                                            }),
                                            t("who.slider.".concat(s.caption))
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var JoinUsTeam = (JoinUsTeamComponent);

// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsWhy.styled.tsx

function JoinUsWhy_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    text-align: center;\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.6;\n\n    strong {\n      font-weight: ",
        ";\n    }\n  }\n"
    ]);
    JoinUsWhy_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JoinUsWhy_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  padding-bottom: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  margin-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  img {\n    display: block;\n  }\n\n  > div {\n    @media (min-width: ",
        ") {\n      padding-top: ",
        ";\n    }\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.5;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  a {\n    font-weight: ",
        ";\n  }\n"
    ]);
    JoinUsWhy_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JoinUsWhy_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  line-height: 1.25;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-weight: ",
        ";\n    font-size: ",
        ";\n  }\n"
    ]);
    JoinUsWhy_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledWhy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-646943e8-0"
})(JoinUsWhy_styled_templateObject(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledCulture = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-646943e8-1"
})(JoinUsWhy_styled_templateObject1(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledCultureTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-646943e8-2"
})(JoinUsWhy_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsWhy.tsx









var JoinUsWhy = function() {
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhy, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("why.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                ns: "join-us",
                i18nKey: "why.desc",
                components: {
                    ethic: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/compromiso-etico-manfred")
                    }),
                    strong: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
                    p: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {})
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCulture, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/joinUs/nailted-badge.svg"),
                        alt: "Nailted badge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCultureTitle, {
                                children: t("why.culture.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                ns: "join-us",
                                i18nKey: "why.culture.desc",
                                components: {
                                    nailtedLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: locale === "en" ? "https://nailted.com/employer-company-culture-advocate-badge " : "https://nailted.com/es/employer-company-culture-advocate-badge"
                                    }),
                                    strong: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
                                    p: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {})
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var joinUs_JoinUsWhy = (JoinUsWhy);

;// CONCATENATED MODULE: ./components/marketingSite/joinUs/JoinUsComponent.tsx









var JoinUsComponent = function(param) {
    var offers = param.offers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        topBarTransparent: true,
        offerFooter: /*#__PURE__*/ (0,jsx_runtime.jsx)(joinUs_JoinUsFooter, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJoinUs, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(joinUs_JoinUsHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinUsTeam, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(joinUs_JoinUsWhy, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(joinUs_JoinUsBenefits, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(joinUs_JoinUsPositions, {
                    offers: offers
                })
            ]
        })
    });
};
/* harmony default export */ var joinUs_JoinUsComponent = (JoinUsComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/join-us.tsx








var JoinUsPage = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("join-us").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("pageTitle"),
                desc: t("join.desc"),
                url: app_urls/* APP_URLS.joinUs */.uu.joinUs,
                imgUrl: "".concat(props.baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_joinus.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(joinUs_JoinUsComponent, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var join_us = (JoinUsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3467,1122,6577,411,9161,9092,3819,9774,2888,179], function() { return __webpack_exec__(18740); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);